import { useCallback, useContext, useEffect, useReducer, useRef, useState } from "react";
import { doc, serverTimestamp, setDoc, Timestamp } from "firebase/firestore"; 
import db, { storage } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { AuthContext } from "../AuthContext";
import { ChatContext } from "../newComponents2/ChatContextApi";
import TextShortenerWithoutButton from "../newComponents2/TextShortener3";
import { HbrAddIcon, HbrCancel, HbrCloseIcon, HbrDeleteIcon, HbrEmoticonIcon, HbrMic, HbrPauseIcon, HbrPlayButtonRound, HbrSendIcon, HbrStopRecording } from "../newComponents/Mycustomsvgicons";
import UseLayout from "../newComponents/useLayout";
import { format } from "date-fns";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { formatMediaTime, ShortenText } from "../newComponents/GeneralClasses";
import EmojiPicker from "../newComponents2/EmojiPicker";
import CustomCircularProgress from "../newComponents2/CustomCircularProgressBar";
import CustomTextArea from "../newComponents2/CustomTextArea";
import AddToNotificationDB from "../newComponents2/AddToNotificationDB";
import { ConstVariables } from "../newComponents2/ConstantVariables";


const Input = () => {
    const[text,setText] = useState("");
    const [img,setImg] = useState(null);
    const [err,setErr] = useState(false);
    const [usernotfound,setUsernotfound]=useState(false);
    const [showReplyView,setShowReplyView] = useState(false);
    const [showMic,setShowMic] = useState(true);
    const [isRecording, setIsRecording] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [audioUrl, setAudioUrl] = useState("");
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [timer, setTimer] = useState(0);
    const [intervalId, setIntervalId] = useState(null);
    const [isSoundActive, setIsSoundActive] = useState(false);
    const [showAudioPlayback,setShowAudioPlayback] = useState(false);
    const [recordedAudioFile,setRecordedFile]=useState(null);
    const [cursorPosittion, setCursorPosition] = useState(0);
    const [wordcount, setWordCount] = useState(false);
    const [isEditable, setIsEditable] = useState(true);
    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, showChatEmojis: false, imageUrl:"", textAreaHeight: 1, notificationText: "", notiificationImage: ""});
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const dataArrayRef = useRef(null);
    const emojiViewRef = useRef(null);
    const now = Timestamp.now();
    const formatdate = new Date(now?.toDate()).toUTCString();
    const messageID = format(new Date(),"yyyyMMddHHmmss");
    const {userName} = useContext(AuthContext);
    const {user_email} = useContext(AuthContext);
    const {verifiedUid} = useContext(AuthContext);
    const {replyData} = useContext(ChatContext);
    const {handleReply} = useContext(ChatContext);
    const {width} = UseLayout();

   


    const handleShowReplyView=useCallback(()=>{
      if (replyData && replyData.isReplyClicked) {
        setShowReplyView(true);
      }
    },[replyData]);
   
    useEffect(()=>{
      handleShowReplyView();
    },[handleShowReplyView]);

    const clearImg=()=>{
      setImg(null);
      setShowMic(true);
    };

    const handleCloseReplyView=()=>{
      setShowReplyView(false);
      handleReply(false, "", "", "", "");
      // console.log(`${replyData.isReplyClicked} ${replyData.message} ${replyData.displayName} ${replyData.chatImage}`);
    };
     
    const handleSendMessage = async () =>{
      if(verifiedUid){
        setText("");
        if(img){
          const storageRef = ref(storage, 'chat_pics/'+formatdate);
            const uploadTask = uploadBytesResumable(storageRef, img);

            uploadTask.on( 

                (error) => {
                  setErr(true);
                }, 
                () => {
                
                  getDownloadURL(uploadTask.snapshot.ref).then(async(downloadURL) => {
                     await setDoc(doc(db,"CHAT3",messageID),{
                        message: text,
                        messageID,
                        usercode: "",
                        date_sent: formatdate,
                        user_name: userName,
                        user_email: user_email,
                        audio_url: "",
                        chat_image: downloadURL,
                        replyTo: replyData.displayName ? replyData.displayName : "",
                        chatImageRepliedTo: replyData.chatImage ? replyData.chatImage : "",
                        messageRepliedTo: replyData.messageRepliedTo ? replyData.messageRepliedTo : "",
                        timestamp: serverTimestamp(),
                    });
                    dispatch({type: actionConsts.NOTIFICATION_IMAGE, payload: downloadURL});
                    dispatch({type: actionConsts.NOTIFICATIONTEXT, payload: `${userName}: ${ShortenText(text, 50)}`});
                    AddToNotificationDB(
                      ConstVariables.CHAT_ROOM_TITLE,
                      state.notificationText,
                      state.notiificationImage !== "" ? state.notiificationImage : ConstVariables.DUMMI_IMAGE,
                      ConstVariables.FAKEPOSTID,
                      "",
                      ConstVariables.CHAT_ROOM_TOPIC,
                      user_email
                    );
                   
                  })
                  .catch ((error) =>{
                    console.log(error);
                  });
                }
              );

        }else{
          await setDoc(doc(db,"CHAT3",messageID),{
              message: text,
              messageID,
              usercode: "",
              date_sent: formatdate,
              user_name: userName,
              user_email: user_email,
              audio_url: "",
              chat_image: "",
              replyTo: replyData.displayName !== null ? replyData.displayName : "",
              chatImageRepliedTo: replyData.chatImage  !== null ? replyData.chatImage : "",
              messageRepliedTo: replyData.message  !== null ? replyData.message : "",
              timestamp: serverTimestamp(),
          });
          dispatch({type: actionConsts.NOTIFICATIONTEXT, payload: `${userName}: ${ShortenText(text, 50)}`});
          AddToNotificationDB(
            ConstVariables.CHAT_ROOM_TITLE,
            state.notificationText,
            state.notiificationImage !== "" ? state.notiificationImage : ConstVariables.DUMMI_IMAGE,
            ConstVariables.FAKEPOSTID,
            "",
            ConstVariables.CHAT_ROOM_TOPIC,
            user_email
          );
        }
          setImg(null);
          setShowReplyView(false);
          setShowMic(true);
      }else{
        setUsernotfound(true);
      }

    };

    useEffect(()=>{
      let words = text.split(' ');
       if(words.length >= 1000){
           words = words.slice(0, 1000);
           setText(words.join(' '));
           setWordCount(words.length);
           setIsEditable(false);
       }else{
         setIsEditable(true);
       }
   },[text]);

    const handleTextchange=(e)=>{
      setText(e.target.value);
      setCursorPosition(e.target.selectionStart);
      if (e.target.value === "") {
        setShowMic(true);
      }else{
        setShowMic(false);
      }
    };

    const handleFocus=(e)=>{
      setCursorPosition(e.target.selectionStart);
    };

    const handleKeyDown=(e)=>{
      if(wordcount >= 500 && !isEditable && e.key !== 'Backspace' && e.key !== 'Delete'){
          e.preventDefault(); 
      }
    };
    

    const startRecording = async () =>{
      const stream = await navigator.mediaDevices.getUserMedia({audio: true});
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      analyserRef.current = audioContextRef.current.createAnalyser();
      const source = audioContextRef.current.createMediaStreamSource(stream);
      source.connect(analyserRef.current);
      analyserRef.current.fftSize = 2048;
      dataArrayRef.current = new Uint8Array(analyserRef.current.fftSize);
      const recorder = new MediaRecorder(stream);
      setMediaRecorder(recorder);

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          setAudioChunks((prev) => [...prev, event.data]);
          // console.log('Data available:', event.data);
        } 
      };

      recorder.onstart = () =>{
        setIsRecording(true);
        const id = setInterval(() => {
          setTimer(prev => prev + 1);
        }, 1000);
        setIntervalId(id)
      };

      recorder.onstop = () =>{
        clearInterval(intervalId);
      }
      recorder.start();
    };

    const pauseRecording = () =>{
      if (mediaRecorder && mediaRecorder.state === 'recording') {
        mediaRecorder.pause();
        setIsPaused(true);
        clearInterval(intervalId);
      }
    };

    const resumeRecording = () =>{
      if (mediaRecorder && mediaRecorder.state === 'paused') {
        mediaRecorder.resume();
        const id = setInterval(() => {
           setTimer(prev => prev + 1);
        }, 1000);
        setIntervalId(id);
        setIsPaused(false);
      }
    };

    const stopRecording = () =>{
      if (mediaRecorder) {
        mediaRecorder.stop();
        setIsRecording(false);
        setIsPaused(false);
        setShowAudioPlayback(true);
        clearInterval(intervalId);
      }
    };

    const cancelRecording = () =>{
      if (mediaRecorder) {
        mediaRecorder.stop();
        setIsPaused(false);
        setAudioChunks([]);
        clearInterval(intervalId);
        setIsRecording(false);
        setTimer(0);
      }
    };

    const startAudioAnalysis = useCallback(()=>{
      const checkAudio = () =>{
        analyserRef.current.getByteTimeDomainData(dataArrayRef.current);
        const isSound = dataArrayRef.current.some(value => value > 126 + 10 || value < 128 -10);
        setIsSoundActive(isSound);
        if (isRecording) {
          requestAnimationFrame(checkAudio)
        }
      };
      checkAudio();
    },[isRecording]);

    const stopAudioAnalysis = () =>{
      if (audioContextRef.current) {
        audioContextRef.current.close();
      }
      setIsSoundActive(false);
    };

    useEffect(()=>{
      if (isRecording) {
        startAudioAnalysis();
      }else{
        stopAudioAnalysis();
      }
    },[isRecording,startAudioAnalysis]);

    useEffect(()=>{
      if (audioChunks.length > 0) {
        const audioBlob = new Blob(audioChunks, {type: 'audio/m4a'});
        const url = URL.createObjectURL(audioBlob);
        setRecordedFile(audioBlob);
        setAudioUrl(url);
      }
    },[audioChunks]);

  //   const saveAudioLocally = async (audioBlob) => {
    
  //     try {
  //       const file_id = format(new Date(),"yyyyMMddHHmmss");
  //         const handle = await window.showSaveFilePicker({
  //             suggestedName: `${file_id}.webm`,
  //             types: [{
  //                 description: 'Audio Files',
  //                 accept: { 'audio/webm': ['.webm'] },
  //             }],
  //         });
  //         const writable = await handle.createWritable();
  //         await writable.write(audioBlob);
  //         await writable.close();
  //         console.log('Audio saved locally');
  //     } catch (error) {
  //         console.error('Error saving audio locally:', error);
  //     }
  // };

    const handleSendAudio=()=>{
      if (recordedAudioFile !== null) {
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
        const file_id = format(new Date(),"yyyyMMddHHmmss");
        const storageRef = ref(storage,`chat_audio/${file_id}.m4a`);
        const uploadTask = uploadBytesResumable(storageRef,recordedAudioFile);

        uploadTask.on(
          (error)=>{
            setErr(true);
          },
          ()=>{
            getDownloadURL(uploadTask.snapshot.ref)
            .then(async(downloadURL) => {
              await setDoc(doc(db,"CHAT3",messageID),{
                message: text,
                messageID,
                usercode: "",
                date_sent: formatdate,
                user_name: userName,
                user_email: user_email,
                audio_url: downloadURL,
                web_audio_duration: `${formatMediaTime(timer)}`,
                chat_image: "",
                timestamp: serverTimestamp(),
              });
              AddToNotificationDB(
                ConstVariables.CHAT_ROOM_TITLE,
                `${userName} sent a voice audio to the chat room`,
                ConstVariables.DUMMI_IMAGE,
                ConstVariables.FAKEPOSTID,
                "",
                ConstVariables.CHAT_ROOM_TOPIC,
                user_email
              );
              dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
              handleDiscardRecordedAudio();
              setIsSoundActive(false);
            }).catch((err)=>{
              dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
              setTimer(0);
            });
          }
        )
      }
    };

    const handleDiscardRecordedAudio=()=>{
      setRecordedFile(null);
      setShowAudioPlayback(false);
      setAudioChunks([]);
      setIsSoundActive(false);
      setTimer(0);
    };

    const addEmojiToText=(emoji)=>{
      // setText((prev)=>prev + emoji);
      const textBeforeCursor = text.substring(0, cursorPosittion);
      const textAfterCursor = text.substring(cursorPosittion);
      setText(textBeforeCursor + emoji + textAfterCursor);
      setTimeout(() => {
        const textarea = document.getElementById('customtextarea');
        textarea.selectionStart = textarea.selectionEnd = cursorPosittion + emoji.length;
      }, 0);
      setShowMic(false);
    };

    useEffect(() => {
      const emojiLayout = document.querySelector('.emojislayout');
      if (state.showChatEmojis) {
        emojiLayout.style.display = 'grid';
        requestAnimationFrame(() => {
          emojiLayout.classList.add('show');
        });
      } else {
          emojiLayout.classList.remove('show');
          emojiLayout.addEventListener('transitionend', () => {
            emojiLayout.style.display = 'none';
          }, { once: true });
      }
    }, [state.showChatEmojis]);

    const handleImageSelectedChange=(e)=>{
      const imageFile = e.target.files[0];
      const url = URL.createObjectURL(imageFile);
        dispatch({type: actionConsts.IMAGE_URL, payload: url});
        setImg(imageFile);
        setShowMic(false);
    };

   
    useEffect(()=>{
      const closeEmojiView=(e)=>{
        if (emojiViewRef.current) {
          if (!emojiViewRef.current.contains(e.target) && state.showChatEmojis) {
            dispatch({type: actionConsts.SHOW_CHAT_EMOJIS})
          }
        }
      };
      document.addEventListener("mousedown", closeEmojiView);
      return()=>document.removeEventListener("mousedown", closeEmojiView);
   },[state.showChatEmojis]);


    return ( 
    <div className="input">

        {replyData &&
                <div className={`showreplyview flex-spacebetween ${showReplyView ? 'show' : 'hide'}`} style={{minHeight:"100px", width:"90%", backgroundColor:"#29335c",
                borderRadius:"10px",border:"4px solid white", borderLeft:"5px solid #eb268f",  zIndex:"2"}}>

                <div className="flex-row2" style={{width:"80%"}}>
                    <div className="repliedbodyview flex-column1" style={{gap:"5px"}}>
                        <p style={{fontWeight:"bold", color:"white"}}>{`ReplyTo: ${replyData.displayName}`}</p>

                        {replyData.audioDuration !== "" ? 
                        <p style={{color:"white"}}>{`🎵 chat audio ${replyData.audioDuration}`}</p>
                        :
                        <TextShortenerWithoutButton fullText={replyData.message} words={width < 600 ? 10 : 80}/>
                        }
                    </div>

                    {replyData.chatImage !== null && replyData.chatImage !== "" && <img src={replyData.chatImage} alt="" />}
                </div>
            
                <HbrCancel width={"1.8em"} height={"1.8em"} fillColour={"#ffffff"} handleClick={handleCloseReplyView}/>
            </div>
        }

        {!isRecording && 
            <div>
              {width <= 500 ? 
              <HbrEmoticonIcon width={"1.7em"} height={"1.7em"} fillColour={"#ffffff"} handleClick={()=>dispatch({type: actionConsts.SHOW_CHAT_EMOJIS})}/>
              :
              <HbrEmoticonIcon width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={()=>dispatch({type: actionConsts.SHOW_CHAT_EMOJIS})}/>
              }
         
           </div>
        }
         
        <div className={`emojislayout ${state.showChatEmojis ? 'show':'hide'}`} ref={emojiViewRef}>
            <EmojiPicker addEmojiToText={addEmojiToText}/>
        </div>
         
     
         {/* {!isRecording && (<textarea type="text" placeholder="Message" rows={1} value={text} onChange={handleTextchange} />)} */}
         {!isRecording && 
         (<CustomTextArea 
          value={text}
          onChange={handleTextchange}
          handleFocus={handleFocus}
          handleClick={handleFocus} 
          handleKeyDown={handleKeyDown}
          hint={"Tyoe a message"} 
          maxRows={5} 
          textareaLineHeight={24}/>
          )}

         {isRecording && 
              <div className="recordingcontrols flex-spacebetween" style={{width:"100%"}}>

                <HbrDeleteIcon width={"1.8em"} height={"1.8em"} fillColour={"#ffffff"} handleClick={cancelRecording} />
                
                {!isPaused &&  <HbrPauseIcon width={"1.8em"} height={"1.8em"} fillColour={"#ffffff"} handleClick={pauseRecording}/>}
               
                {isPaused && <HbrPlayButtonRound width={"1.8em"} height={"1.8em"} fillColour={"#ffffff"} handleClick={resumeRecording}/>}

                <HbrStopRecording width={"1.8em"} height={"1.8em"} fillColour={"red"} handleClick={stopRecording}/>

                <p style={{color:"white",caretColor:"transparent"}}>{formatMediaTime(timer)}</p>
            </div>
         }

         <div className={`recordedfileplayback flex-row2 ${showAudioPlayback ? 'show': 'hide'}`}>
              <audio src={audioUrl} controls controlsList="nodownload noremoteplayback"/>
              <div style={{borderRadius:"50%", backgroundColor:"teal", padding:"5px"}}>
                <HbrSendIcon width={"1.7em"} height={"1.7em"} fillColour={"white"} handleClick={()=>handleSendAudio()}/>
              </div>

              <div style={{borderRadius:"50%", backgroundColor:"red", padding:"5px"}}>
                <HbrCloseIcon width={"1.7em"} height={"1.7em"} fillColour={"white"} handleClick={()=>handleDiscardRecordedAudio()}/>
              </div>
         </div>

        {img &&
          <div className="chatimageselected">
              <div style={{position:"relative"}}>
                <img src={state.imageUrl} alt="" />
                <div style={{position:"absolute", right:"2PX", top:"2px", background:"#00000050"}}>
                  <HbrCancel width={"1.8em"} height={"1.8em"} fillColour={"#ffffff"} handleClick={()=>clearImg()}/>
                </div>
              </div>
          </div> 
        } 

        <div className="send">
            <input type="file"  id="file" accept="image/*" style={{display: "none"}} onChange={handleImageSelectedChange}/>
            {!isRecording && 
              <label htmlFor="file">
                 <HbrAddIcon width={"1.8em"} height={"1.8em"} fillColour={"#ffffff"}/>
              </label>    
            }
        
            <div className={`recordingmic ${isSoundActive ? 'active' : 'dormant'}`}>
                {showMic ? 
                <div>
                    {!isRecording ?
                      <HbrMic width={"1.7em"} height={"1.7em"} fillColour={"white"} handleClick={startRecording}/> 
                      :
                      <HbrMic width={"1.7em"} height={"1.7em"} fillColour={"red"}/> 
                    }
                </div>  
        
                :  
                <HbrSendIcon width={"1.7em"} height={"1.7em"} fillColour={"white"} handleClick={handleSendMessage}/>
                }
              
            </div> 
        </div>
 

        {err && <span>Unable to upload image</span>}
        {usernotfound && 
                  <div className="toast2">
                  <p style={{color:"white",fontWeight:"bold"}}>
                    Action revoked, user not found This alert often shows if the user is blocked.
                    contact support team for help.
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setUsernotfound(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="30px"
                    width="30px">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
              </div>
            }

            {state.progressIndicator && 
                (<CustomCircularProgress borderColor={"black"} borderTopColor={"white"} borderBottomColor={"white"} top={"30%"} left={"44%"}/>)
            }
    </div>
     );
}
export default Input;